import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function isValidCardNumber(number) {
    const digits = number.replace(/\D/g, '');
    let sum = 0;
    let shouldDouble = false;
    for (let i = digits.length - 1; i >= 0; i--) {
        let digit = parseInt(digits[i]);

        if (shouldDouble) {
            digit *= 2;
            if (digit > 9) digit -= 9;
        }

        sum += digit;
        shouldDouble = !shouldDouble;
    }
    return sum % 10 === 0 && number.length === 16;
}

/* Credit Card Number Requirement */
export function creditCardNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null;
        return isValidCardNumber(control.value) ? null : { creditCardNumber: true };
    };
}

/* Expiration Date Requirement */
export function creditCardExpirationDateValidator(): ValidatorFn {
    let expDateFormat: RegExp = /^(0[1-9]|1[0-2])\d{2}$/;
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null;
        const format = expDateFormat.test(control.value);
        return format ? null : { expDate: true };
    };
}


